






























































import { createComponent } from "@vue/composition-api";
import {
  BaseResultsPanel,
  BasePrimaryButton
} from "@web-components";

import PercentagePopulation from "@dcc/components/PercentagePopulation.vue";
import { findGetters as findProfileGetters } from "@dcc/store/profile/getters";
import { findGetters as findScoreGetters } from "@dcc/store/score/getters";
import { riskToColour } from "@dcc/constants/riskLevels";
import { useDictionary } from "@dcc/views/compositions/useDictionary";
import { SHOW_TIPS_LINK } from "@dcc/constants/links";
import { getActions } from "@dcc/store/score/actions";
export default createComponent({
  components: {
    PercentagePopulation,
    BaseResultsPanel,
    BasePrimaryButton
  },
  setup(props: {}, context) {
    const { getGender } = findProfileGetters(context.root.$store);
    const gender = getGender();
    const dictionary = useDictionary();

    const { getPercentWhoDrinkLess, getRiskLevel } = findScoreGetters(
      context.root.$store
    );
    const percentage = getPercentWhoDrinkLess();
    const riskLevel = getRiskLevel();

    const riskColourClass = riskToColour[riskLevel.value];

    const { trackDFDEvent } = getActions(context.root.$store);
    trackDFDEvent();

    return {
      gender,
      percentage,
      riskLevel,
      router: context.root.$router,
      riskColourClass,
      ...dictionary,
      SHOW_TIPS_LINK
    };
  }
});
